import { StoreState } from "store/rootReducer";

export const clientSecretSelector = (store: StoreState) => store.stripe.clientSecret;
export const paymentIntentIdSelector = (store: StoreState) => store.stripe.paymentIntentId;
export const stripeSubscriptionSelector = (store: StoreState) => store.stripe?.subscription;
export const paymentMethodSelector = (store: StoreState) => store.stripe?.paymentMethod;
